import { useState } from 'react';
import { Add } from '@mui/icons-material';
import { Typography } from '@mui/material';
import ListItem from "Components/ListItem";
import ListItemAction from "Components/ListItemAction";
import ListItemActions from "Components/ListItemActions";
import ListItemContent from "Components/ListItemContent";
import { ExportDocument } from 'system/Domain';

interface Props {
	onNewDocument: (d: ExportDocument) => void
	disabled: boolean
}

const SaleExportDocumentNew = (props: Props) => {
	const [isSubmitting, setIsSubmitting] = useState(false);

	const addOtherDocument = async () => {
		setIsSubmitting(true);
		try {
			let newOther: ExportDocument;
			newOther = {
				documentType: "Other",
				file: null
			};
			props.onNewDocument(newOther)
		} finally {
			setIsSubmitting(false);
		}
	};

	return (
		<ListItem
			transparent={isSubmitting || props.disabled}
			color="info"
		>
			<ListItemActions>
				<ListItemAction
					icon={<Add />}
					disabled={isSubmitting || props.disabled}
					onClick={addOtherDocument}
				/>
			</ListItemActions>
			<ListItemContent
				onClick={!(isSubmitting || props.disabled) ? addOtherDocument : null}
			>
				<Typography variant="subtitle2">Weiteres Dokument hinzufügen</Typography>
			</ListItemContent>
		</ListItem>
	);
};

export default SaleExportDocumentNew;
